import Card, { CardData, CardProps } from './Card';
import { useIsDesktop } from 'v1/hooks/use-is-media-query';
import { Box } from 'v1/ui';

export default function Cards({ cards }: { cards: CardData[] }) {
  const isDesktop = useIsDesktop();
  const cardsWithIndex = cards.map((card, index) => ({ ...card, index }));
  if (isDesktop) {
    return <DesktopCards cards={cardsWithIndex} />;
  } else {
    return <MobileCards cards={cardsWithIndex} />;
  }
}

// Two column layout
function DesktopCards({ cards }: { cards: CardProps[] }) {
  return (
    <Box
      sx={{
        mx: 'auto',
        pt: 32,
        overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          pr: 3,
          '& > div': { maxWidth: 309 },
        }}
      >
        <Box sx={{ mt: 64, mr: 24, pb: 64 }}>
          {evenCards(cards).map((card) => (
            <Card key={card.title} {...card} />
          ))}
        </Box>
        <Box sx={{ pb: 64 }}>
          {oddCards(cards).map((card, index) => (
            <Card key={card.title} {...card} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}

// One column layout
function MobileCards({ cards }: { cards: CardProps[] }) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 380,
        mx: 'auto',
        py: 32,
        overflowY: [null, 'auto'],
      }}
    >
      {cards.map((card) => (
        <Card key={card.title} {...card} />
      ))}
    </Box>
  );
}

function evenCards(cards: CardProps[]) {
  return cards
    .filter((val, index) => index % 2 === 0)
    .map((card) => ({
      ...card,
      index: card.index + 1,
    }));
}

function oddCards(cards: CardProps[]) {
  return cards
    .filter((val, index) => index % 2 === 1)
    .map((card) => ({
      ...card,
      index: card.index - 1,
    }));
}
